<template>
  <div class="painel">
    <div class="head-panel">
        <i class="fas fa-edit mr-2"></i>INFORMAÇÕES
    </div>
    <div class="body-panel">
        <p class="sub-title-panel">Dados colaborador</p>
         <div class="d-flex">
            <div class="w-100">
                <label class="label-panel">Código</label>
                <div class="result-panel">{{datadespesa.funcionario.codigo}}</div>
            </div>
        </div>
        <div class="d-flex">
            <div class="w-100">
                <label class="label-panel">Colaborador</label>
                <div :style="datadespesa.funcionario.demissao !== null ?  'color: red' : 'color: #666666'" class="result-panel">{{datadespesa.funcionario.nome == null ? 'N/D' : datadespesa.funcionario.nome }}</div>
            </div>
        </div>
        <div class="d-flex">
            <div class="w-50">
                <label class="label-panel">Data</label>
                <div class="result-panel">{{datadespesa.dataAcaoFormatadaNotHour}}</div>
            </div>
            <div class="w-50">
                <label class="label-panel">Obra</label>
                <div class="result-panel">{{datadespesa.obra.referencia == null ? 'N/D' : datadespesa.obra.referencia  }}</div>
            </div>
        </div>
        <p class="sub-title-panel">Dados da Despesas</p>
          <div class="d-flex">
            <div class="w-50">
                <label class="label-panel">Quantidade</label>
                <div class="result-panel">{{datadespesa.quantidade}}</div>
            </div>
            <div class="w-50">
                <label class="label-panel">Valor</label>
                <div class="result-panel">{{formatMoney(datadespesa.valor)}}</div>
            </div>
        </div>
          <div class="d-flex">
            <div class="w-50">
                <label class="label-panel">Categoria</label>
                <div class="result-panel">{{datadespesa.subCategoriaDescricao}}</div>
            </div>
        </div>
        <div class="d-flex margin" v-if="datadespesa.statusDespesa !== 9">
            <div class="w-100">
                <p class="label-panel label-data">Data Aprovação Técnico</p>
                <p class="result-panel">{{datadespesa.dataAtualizacaoControladoria == null ? 'N/D' : datadespesa.dataAtualizacaoControladoriaFormatada}}</p>
            </div>
        </div>
        <div class="d-flex margin" v-if="datadespesa.statusDespesa !== 9 && datadespesa.statusDespesa !== 1">
            <div class="w-100">
                <p class="label-panel label-data">Data Aprovação Coordenador</p>
                <p class="result-panel">{{datadespesa.dataAtualizacaoCoordenadorFormatada == null ? 'N/D' : datadespesa.dataAtualizacaoCoordenadorFormatada}}</p>
            </div>
        </div>
        <div class="d-flex margin" v-if="datadespesa.statusDespesa !== 9 && datadespesa.statusDespesa !== 1">
            <div class="w-100">
                <p class="label-panel label-data">Data Aprovação Controladoria</p>
                <p class="result-panel">{{datadespesa.dataAtualizacaoControladoria == null ? 'N/D' : datadespesa.dataAtualizacaoControladoriaFormatada}}</p>
            </div>
        </div>
        <div class="d-flex margin" v-if="datadespesa.dataMotivoRecusa != null">
            <div class="w-100">
                <p class="label-panel label-data">Data da Devolução</p>
                <p class="result-panel">{{datadespesa.dataMotivoRecusa == null ? 'N/D' : datadespesa.dataMotivoRecusaFormatada}}</p>
            </div>
        </div>
        <div class="d-flex margin" v-if="datadespesa.dataEdicao != null">
            <div class="w-100">
                <p class="label-panel label-data">Data da Edição</p>
                <p class="result-panel">{{datadespesa.dataEdicaoFormatada}}{{ datadespesa.dataEdicaoUsuario ? ' - ' + nomeCurto(datadespesa.dataEdicaoUsuario) : '' }}</p>
            </div>
        </div>
         <p class="sub-title-panel">Funcionários Vinculados</p>

        <div class="w-100" v-for="(data, index) in datadespesa.funcionarioVinculados" :key="data.id">
            <label class="label-panel">Código do Funcionário - {{index + 1}}</label>
            <div class="result-panel">{{  data.funcionario.codigo + " - "+ data.funcionario.nome  }}</div>
        </div>
        <!-- Botoes de aprovacao REMOVIDOS do painel de detalhe (2026-06-19): aprovacao so pelo topo do grid (padrao igual viagem). Detalhe = somente leitura. -->

    </div>
  </div>
</template>

<script>
import paneldetailsdespesas from './paneldetailsdespesas'
export default paneldetailsdespesas
</script>

<style scoped>
.margin{
margin-top: 0.3rem;
}

.painel{
    width: 100%;
    background: white;
    border-radius: 10px;
}
.body-panel{
    padding: 25px;
    height: fit-content;
}
.button-footer{
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: none;
    border-radius: 10px;
}
.head-panel{
    height: 40px;
    color: #008144;
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    padding-left: 25px;
    background:  #eceff1;
}
.sub-title-panel{
    font-size: 16px;
    color: #008144;
    font-weight: bold;
    margin-top: 15px;
    margin-bottom: 20px;
}
.label-panel{
    font-size: 14px;
    line-height: 0px;
    font-weight: 400;
}
.button-rep{
    width: 75%;
    height: 5vh;
    background: rgb(187, 0, 0);
    color: white;
    border-radius: 5px;
    border: none;
    font-weight: bold;
}
.button-apr{
    width: 75%;
    height: 5vh;
    background: #008144;
    color: white;
    border-radius: 5px;
    border: none;
    font-weight: bold;
}
.result-panel{
    font-size: 14px;
    margin-bottom: 10px;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/paneldetailsdespesas/paneldetailsdespesas.vue